import React, { useEffect, useState } from 'react';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Input } from "reactstrap";
import SimpleBar from 'simplebar-react';

function CustomSelectWithSearch({ className = "form-select", validation = "", placeholder = "Select Item", options = [],
  value = "", onChange = null, disabled = false, tag = "button", style = {}, ref }) {
  const [state, setState] = useState("");
  const [flagImg, setFlagImg] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);

  useEffect(() => {
    setState((value || ""));
    if (value.hasOwnProperty('flagImg')) {
      setFlagImg(value.flagImg);
    }
    setFilteredOptions(options);
  }, [value]);

  useEffect(() => {
    setFilteredOptions(options)
  }, [options]);

  function handleSearch(e) {
    const searchValue = e.target.value.toLowerCase();
    if (searchValue === '') {
      setFilteredOptions(options);
    } else {
      const filtered = options.filter((option) => {
        if (option.name.toLowerCase().includes(searchValue)) {
          return option;
        }
      });
      setFilteredOptions(filtered);
    }
  }

  /**
   * Handles the click event for an item in the dropdown menu.
   *
   * @function
   * @param {string} item - The selected item
   */
  function handleChange(item) {
    setState(item?.name);
    if (item.hasOwnProperty("flagImg")) {
      setFlagImg(item?.flagImg);
    }
    if (typeof onChange === "function") {
      onChange(item);
    }
  };

  return (
    <UncontrolledDropdown disabled={disabled} ref={ref}>
      <DropdownToggle
        tag={tag}
        type="button"
        className={`d-flex align-items-center justify-cont user-select-none ${className} ` + (!disabled ? validation : "disabled")}
        style={style}
      >
        {flagImg !== "" ?
          <img src={flagImg} className='me-1 rounded' height="15" />
          : null}
        {(state === "" ?
          <p className='m-0 text-muted w-100 text-start text-truncate'>{placeholder}</p>
          :
          <p className='m-0 w-100 text-start text-truncate'>{state}</p>
        )}
      </DropdownToggle>
      <DropdownMenu className='w-100'>
        <div className="form-icon mb-2 ms-auto me-auto" style={{ width: '90%' }}>
          <Input type='text' className="form-control form-control-icon" placeholder={placeholder} onKeyDown={(event) => handleSearch(event)} />
          <i className="ri-search-line search-icon text-muted"></i>
        </div>
        <SimpleBar style={{ width: '100%', maxHeight: "220px", overflowX: "hidden" }}>
          {filteredOptions.length > 0 ? (filteredOptions || []).map((item, idx) => {
            return (
              <DropdownItem className='white-space-prewrap' onClick={() => handleChange(item)} key={idx}>
                {item.hasOwnProperty('flagImg') ? <img className='rounded me-1' height="15" src={item?.flagImg} /> : null}
                {item.hasOwnProperty('name') ? item.name : item}
              </DropdownItem>
            )
          }) : null}
        </SimpleBar>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}
export default CustomSelectWithSearch;